module.exports = __webpack_public_path__ + "img/blocked-red-icon.9ecc19c6.svg";